import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'app-position-data',
  templateUrl: './position-data.component.html',
  styleUrl: './position-data.component.scss'
})
export class PositionDataComponent implements OnInit {

  @Input()
  public expanded = false;

  public loaded = false;

  @Input()
  public isAllowEdit: boolean;

  @Input()
  public mainForm: UntypedFormGroup;

  @Input()
  public get positionName(): string {
    return this.mainForm?.get('name')?.value;
  }

  @ViewChild('panel')
  panel: MatExpansionPanel;

  ngOnInit(): void {
   
  }

}
